// FETCH ALL PROCESS_FLOW
export const FETCH_PROCESS_FLOW_REQUEST = 'FETCH_PROCESS_FLOW_REQUEST';
export const FETCH_PROCESS_FLOW_SUCCESS = 'FETCH_PROCESS_FLOW_SUCCESS';
export const FETCH_PROCESS_FLOW_FAILURE = 'FETCH_PROCESS_FLOW_FAILURE';

// FETCH ALL PROCESS_FLOW
export const FETCH_PROCESS_FLOW_WITHOUT_ID_REQUEST = 'FETCH_PROCESS_FLOW_WITHOUT_ID_REQUEST';
export const FETCH_PROCESS_FLOW_WITHOUT_ID_SUCCESS = 'FETCH_PROCESS_FLOW_WITHOUT_ID_SUCCESS';
export const FETCH_PROCESS_FLOW_WITHOUT_ID_FAILURE = 'FETCH_PROCESS_FLOW_WITHOUT_ID_FAILURE';

// CREATE PROCESS_FLOW
export const CREATE_PROCESS_FLOW_REQUEST = 'CREATE_PROCESS_FLOW_REQUEST';
export const CREATE_PROCESS_FLOW_SUCCESS = 'CREATE_PROCESS_FLOW_SUCCESS';
export const CREATE_PROCESS_FLOW_FAILURE = 'CREATE_PROCESS_FLOW_FAILURE';

// UPDATE PROCESS_FLOW
export const UPDATE_PROCESS_FLOW_REQUEST = 'UPDATE_PROCESS_FLOW_REQUEST';
export const UPDATE_PROCESS_FLOW_SUCCESS = 'UPDATE_PROCESS_FLOW_SUCCESS';
export const UPDATE_PROCESS_FLOW_FAILURE = 'UPDATE_PROCESS_FLOW_FAILURE';

// FETCH SINGLE STATE OF PROCESS_FLOW
export const FETCH_SINGLE_PROCESS_FLOW_REQUEST = 'FETCH_SINGLE_PROCESS_FLOW_REQUEST';
export const FETCH_SINGLE_PROCESS_FLOW_SUCCESS = 'FETCH_SINGLE_PROCESS_FLOW_SUCCESS';
export const FETCH_SINGLE_PROCESS_FLOW_FAILURE = 'FETCH_SINGLE_PROCESS_FLOW_FAILURE';

// FETCH SINGLE STATE OF PROCESS_FLOW
export const FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_REQUEST = 'FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_REQUEST';
export const FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_SUCCESS = 'FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_SUCCESS';
export const FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_FAILURE = 'FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_FAILURE';

// FETCH ALL PROCESS_FLOW
export const FETCH_SEQUENCE_NUMBER_REQUEST = 'FETCH_SEQUENCE_NUMBER_REQUEST';
export const FETCH_SEQUENCE_NUMBER_SUCCESS = 'FETCH_SEQUENCE_NUMBER_SUCCESS';
export const FETCH_SEQUENCE_NUMBER_FAILURE = 'FETCH_SEQUENCE_NUMBER_FAILURE';

// DELETE PROCESS_FLOW
export const DELETE_PROCESS_FLOW_REQUEST = 'DELETE_PROCESS_FLOW_REQUEST';
export const DELETE_PROCESS_FLOW_SUCCESS = 'DELETE_PROCESS_FLOW_SUCCESS';
export const DELETE_PROCESS_FLOW_FAILURE = 'DELETE_PROCESS_FLOW_FAILURE';

export const RESET_PROCESS_FLOW_INFO = 'RESET_PROCESS_FLOW_INFO';

export const CREATE_PROCESS_FLOW_FORM = 'CREATE_PROCESS_FLOW_FORM';

export const UPDATE_PROCESS_FLOW_FORM = 'UPDATE_PROCESS_FLOW_FORM';

// NAVIGATE TO PROCESS_FLOW DETAILS COMPONENT
export const NAVIGATE_PROCESS_FLOW_ADD_ON = 'NAVIGATE_PROCESS_FLOW_ADD_ON';

// NAVIGATE TO PROCESS_FLOW DETAILS COMPONENT
export const NAVIGATE_PROCESS_FLOW_SUPPLIER = 'NAVIGATE_PROCESS_FLOW_SUPPLIER';

// NAVIGATE TO PROCESS_FLOW COMPONENT
export const NAVIGATE_PROCESS_FLOW = 'NAVIGATE_PROCESS_FLOW';

export const UPDATE_PROCESS_FLOW_LISTS = 'UPDATE_PROCESS_FLOW_LISTS'
